import { BoxProps } from '@jfs/ui-new'

export const styles = {
  formBox: {
    width: '40%',
  } as BoxProps,
  formWrapperContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 20,
  } as BoxProps,
}
